export const PLAN_DURATION_DAYS = Object.freeze({
  mensal: 30,
  trimestral: 90,
  semestral: 180,
  anual: 365
});

const normalizeDuration = (duration) => (
  String(duration || 'mensal')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
);

export const getPlanDurationDays = (duration) => {
  const normalizedDuration = normalizeDuration(duration);

  if (normalizedDuration === 'vitalicio') return null;

  return PLAN_DURATION_DAYS[normalizedDuration] || PLAN_DURATION_DAYS.mensal;
};

export const calculatePlanExpirationDate = (duration, startDate = new Date()) => {
  const durationDays = getPlanDurationDays(duration);
  if (durationDays === null) return null;

  const baseDate = startDate instanceof Date && !Number.isNaN(startDate.getTime())
    ? startDate
    : new Date();

  const expirationDate = new Date(baseDate);
  expirationDate.setDate(expirationDate.getDate() + durationDays);

  return expirationDate;
};
